import { TextField, IconButton } from '@mui/material';
import theme from 'src/theme';
import styled from 'styled-components';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

export const searchInputStyles = {
    searchLabelSX: {
        color: theme.color.white50,
        fontFamily: '"Inter",sans-serif',
        fontSize: 12,
        lineHeight: '18px'
    },
    searchInputSX: {
        color: theme.color.white50,
        fontFamily: '"Inter",sans-serif',
        fontSize: 10,
        borderBottom: `0.5px solid ${theme.color.white30}`,
        lineHeight: '18px'
    }
};
export const SearchInput = styled(TextField)(
    (props: { width?: string }) => `
    && {
        border: 0.5px solid transparent;
        border-bottom: 0.5px solid ${theme.color.white30};
        width: ${props.width || '300px'};
    }
`
);

export const StyledSearchIcon = styled(SearchIcon)`
    color: ${theme.color.white70};
    width: 18px;
    height: 18px;
`;

export const StyledClearButton = styled(IconButton)`
    padding: 2px;
    opacity: 0.6;
    &:hover {
        opacity: 1;
    }
`;

export const StyledClearIcon = styled(ClearIcon)`
    color: ${theme.color.white30};
    font-size: 16px;
`;
